import * as React from "react";
import { FunctionComponent } from "react";
import { useKeyboard } from "../Nav/useKeyboard";

export const KeyboardObserver: FunctionComponent<{ children?: React.ReactNode }> = ({
  children
}) => {
  useKeyboard();
  return <>{children}</>;
};
